import { render, staticRenderFns } from "./CorrigeODistDasEntidadesDaBdgd.vue?vue&type=template&id=4b7af1e8&"
import script from "./CorrigeODistDasEntidadesDaBdgd.vue?vue&type=script&lang=js&"
export * from "./CorrigeODistDasEntidadesDaBdgd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports